module.exports = __webpack_public_path__ + "static/Mayowa-Ayodeji-1156e96d0da7c6a538210b4468736ebc.jpg";